const playHtml = `
  <button id="play" >Begin Meditation</button>
`;

const PlayButton = document.createElement("DIV");
PlayButton.innerHTML = playHtml;

export default PlayButton;
